<div class="new-item-modal">
  <h3 class="mat-h3">Do you want to {{data.option1}} or {{data.option2}}?</h3>
  @if (data.explanation) {
    <div class="explanation">{{data.explanation}}</div>
  }

  <div class="d-flex align-items-center justify-content-between m-t-48">
    <button
      mat-raised-button
      color="accent"
      (click)="handleOption1Click()">
      {{data.option1Action}}
    </button>
    <button
      mat-raised-button
      color="accent"
      (click)="handleOption2Click()">
      {{data.option2Action}}
    </button>
  </div>
</div>
